import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IHomePagecopy_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHomePagecopy_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Get_Date: any[];
  Get_Date_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Yonetim_FirmaByFirmaNo: any[];
  Get_Yonetim_FirmaByFirmaNo_dummy: any[];
  Get_Home_Summary_FTL_Bekleyen: any[];
  Get_Home_Summary_FTL_Bekleyen_dummy: any[];
  Get_Home_Summary_LTL_Bekleyen: any[];
  Get_Home_Summary_LTL_Bekleyen_dummy: any[];
  Get_Home_Summary_FTL_Tamamlanan: any[];
  Get_Home_Summary_FTL_Tamamlanan_dummy: any[];
  Get_Home_Summary_LTL_Tamamlanan: any[];
  Get_Home_Summary_LTL_Tamamlanan_dummy: any[];
  Rprv2_YukVeren_DashboardOzet: any[];
  Rprv2_YukVeren_DashboardOzet_dummy: any[];
  Sms_Get_Credits: string;
  Sms_Get_Credits_dummy: string;
  isComp200514Visible: "visible" | "hidden";
  isComp338570Visible: "visible" | "hidden";
  isComp664151Visible: "visible" | "hidden";
  isComphomepagecopy_664151AuthorizationVisible: "visible" | "hidden";
}

export class HomePagecopy_ScreenBase extends React.PureComponent<
  IHomePagecopy_ScreenProps,
  any
> {
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "1e91b082-21e1-49a5-8854-e88da6551d1d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 740733,
          PropertyName: "value",
          Value: "Aruna Nakliye Yönetim Portalı",
        },
        { Id: 692118, PropertyName: "value", Value: "Merhaba," },
        { Id: 900581, PropertyName: "value", Value: "Lisans Tipi :" },
        { Id: 790812, PropertyName: "value", Value: "Lisans Bitiş Tarihi :" },
        { Id: 789887, PropertyName: "value", Value: "Kalan SMS Kredisi" },
        { Id: 209655, PropertyName: "value", Value: "Full Truck Sevkiyat" },
        {
          Id: 67523,
          PropertyName: "value",
          Value: "Tamamlanan FTL Sevkiyatlar",
        },
        { Id: 550791, PropertyName: "value", Value: "Yıl" },
        { Id: 982081, PropertyName: "placeholder", Value: "Select Year..." },
        { Id: 245914, PropertyName: "value", Value: "Parsiyel Sevkiyat" },
        {
          Id: 715265,
          PropertyName: "value",
          Value: "Tamamlanan LTL Sevkiyatlar",
        },
        { Id: 969831, PropertyName: "value", Value: "Yıl" },
        { Id: 271474, PropertyName: "placeholder", Value: "Select Year..." },
        { Id: 739714, PropertyName: "value", Value: "Günlük" },
        { Id: 269431, PropertyName: "value", Value: "Aylık" },
        { Id: 215015, PropertyName: "value", Value: "Yıllık" },
        {
          Id: 415971,
          PropertyName: "value",
          Value: "Planlanan Yükleme Sayısı",
        },
        { Id: 510533, PropertyName: "value", Value: "Tedarik Bekleyen Araç" },
        {
          Id: 601053,
          PropertyName: "value",
          Value: "Fabrikaya Ulaşmamış Araç",
        },
        { Id: 116215, PropertyName: "value", Value: "Yükleme Bekleyen Araç" },
        { Id: 310580, PropertyName: "value", Value: "Gerçekleşen Sevkiyat" },
        {
          Id: 393653,
          PropertyName: "value",
          Value: "Planlanan Yükleme Sayısı",
        },
        { Id: 709526, PropertyName: "value", Value: "Tedarik Bekleyen Araç" },
        {
          Id: 616510,
          PropertyName: "value",
          Value: "Fabrikaya Ulaşmamış Araç",
        },
        { Id: 622067, PropertyName: "value", Value: "Yükleme Bekleyen Araç" },
        { Id: 370526, PropertyName: "value", Value: "Gerçekleşen Sevkiyat" },
        {
          Id: 914807,
          PropertyName: "value",
          Value: "Planlanan Yükleme Sayısı",
        },
        { Id: 295932, PropertyName: "value", Value: "Tedarik Bekleyen Araç" },
        {
          Id: 322072,
          PropertyName: "value",
          Value: "Fabrikaya Ulaşmamış Araç",
        },
        { Id: 833311, PropertyName: "value", Value: "Yükleme Bekleyen Araç" },
        { Id: 519016, PropertyName: "value", Value: "Gerçekleşen Sevkiyat" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Get_Date: [],
      ReadFromSessionStorage: "",
      Get_Yonetim_FirmaByFirmaNo: [],
      Get_Home_Summary_FTL_Bekleyen: [],
      Get_Home_Summary_LTL_Bekleyen: [],
      Get_Home_Summary_FTL_Tamamlanan: [],
      Get_Home_Summary_LTL_Tamamlanan: [],
      Rprv2_YukVeren_DashboardOzet: [],
      Sms_Get_Credits: "",
      isComp200514Visible: "hidden",
      isComp338570Visible: "hidden",
      isComp664151Visible: "hidden",
      isComphomepagecopy_664151AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("homepagecopy", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.HomePagecopyPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepagecopy_664151AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "1b1b0964-c981-56ad-7602-38dd4f8725ee",
        "1126c82c-d16e-9976-54d3-19e6419248c5",
        "SuperUser",
        "AracGirisCikis",
        "YuklemeFormen",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight("homepagecopy", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("homepagecopy", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HomePagecopyPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HomePagecopyPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePagecopy/HomePagecopyPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Date = result?.data.get_Date;
    formVars.homepagecopy_982081_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Date !== undefined
        ? stateVars.Get_Date?.length > 0
          ? stateVars.Get_Date[0].yil
          : null
        : this.state.Get_Date?.length > 0
        ? this.state.Get_Date[0].yil
        : null
    );
    formVars.homepagecopy_271474_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Date !== undefined
        ? stateVars.Get_Date?.length > 0
          ? stateVars.Get_Date[0].yil
          : null
        : this.state.Get_Date?.length > 0
        ? this.state.Get_Date[0].yil
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagecopyPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagecopyPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagecopyPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HomePagecopyPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        true
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.HomePagecopyPageInit3_,
        "HomePagecopy",
        "Signin",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagecopyPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePagecopy/HomePagecopyPageInit3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Yonetim_FirmaByFirmaNo =
      result?.data.get_Yonetim_FirmaByFirmaNo;
    formVars.homepagecopy_141793_value = ReactSystemFunctions.toString(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaAdi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaAdi
        : null
    );
    formVars.homepagecopy_291688_value = ReactSystemFunctions.toString(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].lisansTipi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].lisansTipi
        : null
    );
    formVars.homepagecopy_384546_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].lisansBitisTarihi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].lisansBitisTarihi
        : null
    );
    stateVars.isComp200514Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp338570Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp664151Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagecopyPageInit4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagecopyPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "HomePagecopy/HomePagecopyPageInit4_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Home_Summary_FTL_Bekleyen =
        result?.data.get_Home_Summary_FTL_Bekleyen;
      formVars.homepagecopy_877346_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Home_Summary_FTL_Bekleyen !== undefined
          ? stateVars.Get_Home_Summary_FTL_Bekleyen?.length > 0
            ? stateVars.Get_Home_Summary_FTL_Bekleyen[0].bekleyen
            : null
          : this.state.Get_Home_Summary_FTL_Bekleyen?.length > 0
          ? this.state.Get_Home_Summary_FTL_Bekleyen[0].bekleyen
          : null
      );
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit5_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagecopyPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "HomePagecopy/HomePagecopyPageInit5_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Home_Summary_LTL_Bekleyen =
        result?.data.get_Home_Summary_LTL_Bekleyen;
      formVars.homepagecopy_739463_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Home_Summary_LTL_Bekleyen !== undefined
          ? stateVars.Get_Home_Summary_LTL_Bekleyen?.length > 0
            ? stateVars.Get_Home_Summary_LTL_Bekleyen[0].bekleyen
            : null
          : this.state.Get_Home_Summary_LTL_Bekleyen?.length > 0
          ? this.state.Get_Home_Summary_LTL_Bekleyen[0].bekleyen
          : null
      );
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit6_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagecopyPageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      TeslimYili_0: ReactSystemFunctions.convertToTypeByName(2025, "number"),
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "HomePagecopy/HomePagecopyPageInit6_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Home_Summary_FTL_Tamamlanan =
        result?.data.get_Home_Summary_FTL_Tamamlanan;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit7_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagecopyPageInit7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      TeslimatYili_0: ReactSystemFunctions.convertToTypeByName(2025, "number"),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "HomePagecopy/HomePagecopyPageInit7_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Home_Summary_LTL_Tamamlanan =
        result?.data.get_Home_Summary_LTL_Tamamlanan;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit8_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagecopyPageInit8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      Tarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Date !== undefined
            ? stateVars.Get_Date?.length > 0
              ? stateVars.Get_Date[0].gunSqlFilter
              : null
            : this.state.Get_Date?.length > 0
            ? this.state.Get_Date[0].gunSqlFilter
            : null
        ),
        "Date"
      ),
      _Username_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].smsUserName
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].smsUserName
            : null
        ),
        "string"
      ),
      _Password_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].smsPassword
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].smsPassword
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePagecopy/HomePagecopyPageInit8_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Rprv2_YukVeren_DashboardOzet =
      result?.data.rprv2_YukVeren_DashboardOzet;
    formVars.homepagecopy_753595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam
        : null
    );
    formVars.homepagecopy_680930_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen
        : null
    );
    formVars.homepagecopy_50746_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor
        : null
    );
    formVars.homepagecopy_197662_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen
        : null
    );
    formVars.homepagecopy_147739_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis
        : null
    );
    formVars.homepagecopy_895122_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam_Aylik
        : null
    );
    formVars.homepagecopy_521943_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Aylik
        : null
    );
    formVars.homepagecopy_968302_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Aylik
        : null
    );
    formVars.homepagecopy_605454_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Aylik
        : null
    );
    formVars.homepagecopy_291802_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Aylik
        : null
    );
    formVars.homepagecopy_309546_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam_Yillik
        : null
    );
    formVars.homepagecopy_161835_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Yillik
        : null
    );
    formVars.homepagecopy_361807_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Yillik
        : null
    );
    formVars.homepagecopy_488327_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Yillik
        : null
    );
    formVars.homepagecopy_952983_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Yillik
        : null
    );
    stateVars.Sms_Get_Credits = result?.data.sms_Get_Credits;
    formVars.homepagecopy_738977_value = ReactSystemFunctions.toString(
      this,
      stateVars.Sms_Get_Credits
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagecopyPageInit9_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagecopyPageInit9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepagecopy_141793_value = ReactSystemFunctions.toString(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaAdi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaAdi
        : null
    );

    formVars.homepagecopy_291688_value = ReactSystemFunctions.toString(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].lisansTipi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].lisansTipi
        : null
    );

    formVars.homepagecopy_384546_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
        ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
          ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].lisansBitisTarihi
          : null
        : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
        ? this.state.Get_Yonetim_FirmaByFirmaNo[0].lisansBitisTarihi
        : null
    );

    formVars.homepagecopy_738977_value = ReactSystemFunctions.toString(
      this,
      this.state.Sms_Get_Credits
    );

    stateVars.isComp200514Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagecopyPageInit10_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HomePagecopyPageInit10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      formVars.homepagecopy_877346_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Home_Summary_FTL_Bekleyen !== undefined
          ? stateVars.Get_Home_Summary_FTL_Bekleyen?.length > 0
            ? stateVars.Get_Home_Summary_FTL_Bekleyen[0].bekleyen
            : null
          : this.state.Get_Home_Summary_FTL_Bekleyen?.length > 0
          ? this.state.Get_Home_Summary_FTL_Bekleyen[0].bekleyen
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit11_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit11_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagecopyPageInit11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepagecopy_982081_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Date !== undefined
        ? stateVars.Get_Date?.length > 0
          ? stateVars.Get_Date[0].yil
          : null
        : this.state.Get_Date?.length > 0
        ? this.state.Get_Date[0].yil
        : null
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagecopyPageInit12_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HomePagecopyPageInit12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit13_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit13_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagecopyPageInit13_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      stateVars.dataSource_245416 =
        stateVars.Get_Home_Summary_FTL_Tamamlanan ??
        this.state.Get_Home_Summary_FTL_Tamamlanan;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit14_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit14_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagecopyPageInit14_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      formVars.homepagecopy_739463_value = ReactSystemFunctions.toString(
        this,
        stateVars.Get_Home_Summary_LTL_Bekleyen !== undefined
          ? stateVars.Get_Home_Summary_LTL_Bekleyen?.length > 0
            ? stateVars.Get_Home_Summary_LTL_Bekleyen[0].bekleyen
            : null
          : this.state.Get_Home_Summary_LTL_Bekleyen?.length > 0
          ? this.state.Get_Home_Summary_LTL_Bekleyen[0].bekleyen
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit15_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit15_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagecopyPageInit15_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepagecopy_271474_value = ReactSystemFunctions.value(
      this,
      stateVars.Get_Date !== undefined
        ? stateVars.Get_Date?.length > 0
          ? stateVars.Get_Date[0].yil
          : null
        : this.state.Get_Date?.length > 0
        ? this.state.Get_Date[0].yil
        : null
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagecopyPageInit16_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HomePagecopyPageInit16_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit17_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit17_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagecopyPageInit17_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      )
    ) {
      stateVars.dataSource_105487 =
        stateVars.Get_Home_Summary_LTL_Tamamlanan ??
        this.state.Get_Home_Summary_LTL_Tamamlanan;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit18_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyPageInit18_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagecopyPageInit18_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp338570Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp664151Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.homepagecopy_753595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam
        : null
    );

    formVars.homepagecopy_680930_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen
        : null
    );

    formVars.homepagecopy_50746_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor
        : null
    );

    formVars.homepagecopy_197662_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen
        : null
    );

    formVars.homepagecopy_147739_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis
        : null
    );

    formVars.homepagecopy_895122_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam_Aylik
        : null
    );

    formVars.homepagecopy_521943_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Aylik
        : null
    );

    formVars.homepagecopy_968302_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Aylik
        : null
    );

    formVars.homepagecopy_605454_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Aylik
        : null
    );

    formVars.homepagecopy_291802_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Aylik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Aylik
        : null
    );

    formVars.homepagecopy_309546_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].toplam_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].toplam_Yillik
        : null
    );

    formVars.homepagecopy_161835_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].atamaBekleyen_Yillik
        : null
    );

    formVars.homepagecopy_361807_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].aracBekleniyor_Yillik
        : null
    );

    formVars.homepagecopy_488327_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].yuklemeBekleyen_Yillik
        : null
    );

    formVars.homepagecopy_952983_value = ReactSystemFunctions.toString(
      this,
      stateVars.Rprv2_YukVeren_DashboardOzet !== undefined
        ? stateVars.Rprv2_YukVeren_DashboardOzet?.length > 0
          ? stateVars.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Yillik
          : null
        : this.state.Rprv2_YukVeren_DashboardOzet?.length > 0
        ? this.state.Rprv2_YukVeren_DashboardOzet[0].sevkEdilmis_Yillik
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HomePagecopyComponent_542684_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        "1"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.HomePagecopyComponent_542684_onClick1_,
        "HomePagecopy",
        "LeftMenu",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "179034",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyComponent_542684_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagecopyComponent_542684_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.HomePagecopyComponent_542684_onClick2_,
        "HomePagecopy",
        "LeftMenuYukVeren",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "642910",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HomePagecopyComponent_542684_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HomePagecopyComponent_542684_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Yonetim_FirmaByFirmaNo !== undefined
            ? stateVars.Get_Yonetim_FirmaByFirmaNo?.length > 0
              ? stateVars.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
              : null
            : this.state.Get_Yonetim_FirmaByFirmaNo?.length > 0
            ? this.state.Get_Yonetim_FirmaByFirmaNo[0].firmaTipi
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "HomePagecopy",
        "LeftMenuBos",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "973664",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, 179034, 642910, 973664] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HomePagecopyPageInit();
    }
    if (diId == 179034) {
      isErrorOccurred = await this.HomePagecopyComponent_542684_onClick1_();
      if (isErrorOccurred) return true;
    } else if (diId == 642910) {
      isErrorOccurred = await this.HomePagecopyComponent_542684_onClick2_();
      if (isErrorOccurred) return true;
    }
  }
}
